import { render, staticRenderFns } from "./ErpDlsLogErpLogin.vue?vue&type=template&id=56f6401e&scoped=true&"
import script from "./ErpDlsLogErpLogin.vue?vue&type=script&lang=js&"
export * from "./ErpDlsLogErpLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6401e",
  null
  
)

export default component.exports